// Central site configuration and company data.
// Content mirrors the live goldenitc.sa site exactly — do not alter copy without client sign-off.

export const site = {
  name: "Golden International Contracting Co.",
  shortName: "GIC",
  url: "https://goldenitc.sa",
  description:
    "Golden International Contracting Co. (GIC) delivers electro-mechanical (MEP) contracting and logistics solutions across Saudi Arabia since 2006.",
  tagline: "Exceeding Expectations. Delivering Real Value.",
  founded: "2006",
  // Google Analytics 4 Measurement ID — set NEXT_PUBLIC_GA_ID in the environment to enable.
  gaId: process.env.NEXT_PUBLIC_GA_ID ?? "",
} as const;

export const contact = {
  email: "info@goldenitc.sa",
  emailAlt: "info@goldenitc.sa",
  phone: "+966 59 741 6172",
  phoneHref: "tel:+966597416172",
  // WhatsApp runs on the same line as the phone number (client request, July
  // 2026 — the old +966 54 955 1307 number was retired).
  whatsapp: "+966 59 741 6172",
  whatsappHref: "https://wa.me/966597416172",
  address: {
    line1: "6397 - Amir Mutab St, As Safa Dist.",
    line2: "Postal Code: 23453 Jeddah",
    country: "Saudi Arabia",
    city: "Jeddah",
  },
} as const;

// Opens a Gmail compose window (in a new tab) pre-addressed to our team.
// Use with target="_blank" so it reliably opens Gmail regardless of the
// visitor's default mail-app settings.
export function mailto(subject = "Inquiry from goldenitc.sa") {
  const to = encodeURIComponent(contact.email);
  const su = encodeURIComponent(subject);
  return `https://mail.google.com/mail/?view=cm&fs=1&to=${to}&su=${su}`;
}

// Primary navigation. `Services` groups the division pages into a dropdown
// (Contracting / Logistic) while still linking to the /services overview
// itself. Only Header.tsx consumes this.
export const nav = [
  { label: "Home", href: "/" },
  { label: "About Us", href: "/about" },
  {
    label: "Services",
    href: "/services",
    children: [
      { label: "Contracting", href: "/contracting" },
      { label: "Logistic", href: "/logistic" },
    ],
  },
  { label: "Projects", href: "/projects" },
  { label: "Blogs", href: "/blog" },
  { label: "Contact Us", href: "/contact" },
] as const;

export const stats = [
  { value: "300+", label: "Happy Clients" },
  { value: "90+", label: "Completed Projects" },
  { value: "100+", label: "Fleet Vehicles" },
  { value: "16+", label: "Years of Experience" },
] as const;

// Official GIC social profiles (from the live site).
export const socials = [
  { label: "Facebook", href: "https://www.facebook.com/share/1AbBy9i3Lj/?mibextid=wwXIfr" },
  { label: "Instagram", href: "https://www.instagram.com/goldeninternational.sa" },
  { label: "LinkedIn", href: "https://www.linkedin.com/company/golden-international-contracting-company/" },
] as const;

// CEO (Samran Ahsan Warraich) personal profiles — shown on the About page.
export const ceoSocials = [
  { label: "Instagram", href: "https://www.instagram.com/samran_ahsan_warraich" },
  { label: "LinkedIn", href: "https://www.linkedin.com/in/samran-ahsan-b7683b211" },
] as const;

// Contacts specific to the logistics division.
export const divisionContacts = [
  { name: "Ch Hussnain Ahsan Warraich", phone: "+966595600519", href: "tel:+966595600519" },
  { name: "Ch Sajjad Ahmad Tarar", phone: "+966535112648", href: "tel:+966535112648" },
] as const;
